export default {
  courses: 'Courses',
  myCourses: 'My Courses',
  register: 'Register',
  profile: 'Profile',
  login: 'Login',
  logout: 'Logout'
}



// WEBPACK FOOTER //
// ./src/i18n/header/en.js